$('.btn-guide').on('click', function (e) {
  e.preventDefault();
  $('.popup-fit-guide').toggleClass('is-visible');
});

$('.popup-fit-guide .popup__close, .popup-fit-guide .popup__overlay').on('click', function () {
  $('.popup-fit-guide').toggleClass('is-visible');
});

$('[data-tab-id*="fit-guide-popup-"]').on('click', function (e) {
  const id = e.target.dataset.tabId;
  const $this = $(this);

  $('[data-tab-id*="fit-guide-popup-"]').removeClass('is-active');
  $('[id*="fit-guide-popup-"]').removeClass('is-active');
  $this.addClass('is-active');
  $(`#${id}`).addClass('is-active');
});